module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actionlist"
  }, [_c('transition', {
    attrs: {
      "name": "sideDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    ref: "content",
    staticClass: "content"
  }, _vm._l((_vm.menuList), function(item, index) {
    return _c('type-list', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "name": item.name,
        "icon": item.icon,
        "align": item.align,
        "clickItem": _vm.clickItem,
        "count": item.count,
        "action": item.action,
        "color": item.color
      }
    })
  }))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.hideMenuList,
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stopTouch($event)
      }
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08fcdf3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu_current_folder.vue
// module id = 214
// module chunks = 3